import Vue from 'vue';
import { USER_TYPES } from '../constants/user-types';

export default Vue.filter('userType', value => USER_TYPES.find(el => el.data === value).view);


// WEBPACK FOOTER //
// ./src/filters/user-role.js